import { render } from "./Automation.vue?vue&type=template&id=3a77fe20&scoped=true"
import script from "./Automation.vue?vue&type=script&lang=js"
export * from "./Automation.vue?vue&type=script&lang=js"

import "./Automation.vue?vue&type=style&index=0&id=3a77fe20&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a77fe20"]])

export default __exports__